export default function Hero() {
  return (
    <section
      className="relative min-h-screen w-full flex flex-col items-center justify-center overflow-hidden"
      style={{ background: '#0A0A0A' }}
    >
      {/* Background image — abstract/artistic */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20dark%20expressionist%20painting%20ink%20wash%20deep%20black%20and%20gold%20tones%20Nigerian%20textile%20geometry%20organic%20flowing%20patterns%20literary%20manuscript%20atmosphere%20mysterious%20and%20elegant%20artistic%20background%20with%20aged%20paper%20grain%20texture%20and%20subtle%20warm%20amber%20glow&width=1920&height=1080&seq=ws-hero-bg-1&orientation=landscape"
          alt="Abstract literary background"
          className="w-full h-full object-cover object-top opacity-25"
        />
        <div className="absolute inset-0" style={{ background: 'radial-gradient(ellipse at center, transparent 20%, #0A0A0A 80%)' }} />
        <div className="absolute inset-0" style={{ background: 'linear-gradient(to bottom, rgba(10,10,10,0.5) 0%, rgba(10,10,10,0.3) 50%, rgba(10,10,10,0.85) 100%)' }} />
      </div>

      {/* Grain texture overlay */}
      <div
        className="absolute inset-0 z-0 pointer-events-none opacity-[0.04]"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)' opacity='1'/%3E%3C/svg%3E")`,
          backgroundRepeat: 'repeat',
          backgroundSize: '200px',
        }}
      />

      {/* Main content */}
      <div className="relative z-10 flex flex-col items-center text-center px-6 w-full max-w-5xl mx-auto pt-24 pb-16">

        {/* Badge */}
        <div
          className="inline-flex items-center gap-2 px-5 py-2 rounded-full mb-10"
          style={{
            border: '1px solid rgba(201,168,76,0.35)',
            background: 'rgba(201,168,76,0.05)',
          }}
        >
          <span
            className="text-[10px] tracking-[0.3em] uppercase"
            style={{ fontFamily: "'Inter', sans-serif", color: '#C9A84C' }}
          >
            Nobel Laureate &nbsp;·&nbsp; Nigerian Literary Legacy
          </span>
        </div>

        {/* Main typographic title */}
        <h1 className="w-full leading-none mb-0" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
          <span
            className="block font-light"
            style={{
              fontSize: 'clamp(64px, 10vw, 130px)',
              color: '#F5F0E8',
              letterSpacing: '-0.02em',
              lineHeight: 1.0,
            }}
          >
            Timeless
          </span>
          <span
            className="block font-light italic"
            style={{
              fontSize: 'clamp(56px, 9vw, 118px)',
              color: '#C9A84C',
              letterSpacing: '-0.02em',
              lineHeight: 1.05,
            }}
          >
            Memories
          </span>
          <span
            className="block font-light"
            style={{
              fontSize: 'clamp(38px, 6vw, 82px)',
              color: 'rgba(245,240,232,0.55)',
              letterSpacing: '0.02em',
              lineHeight: 1.1,
            }}
          >
            Elastic Effects
          </span>
        </h1>

        {/* Gold divider */}
        <div
          className="w-40 mt-8 mb-8"
          style={{ height: '1px', background: 'linear-gradient(to right, transparent, #C9A84C, transparent)' }}
        />

        {/* Subtitle */}
        <p
          className="max-w-lg text-base font-light leading-relaxed mb-2"
          style={{ fontFamily: "'Cormorant Garamond', serif", color: '#9A9A8A', fontSize: '18px' }}
        >
          A digital sanctuary for the words, wisdom, and world of <strong style={{ color: '#F5F0E8', fontWeight: 400 }}>Wole Soyinka</strong>.
        </p>
        <p
          className="max-w-md text-sm font-light leading-relaxed mb-12"
          style={{ fontFamily: "'Inter', sans-serif", color: '#6B6B60' }}
        >
          Something extraordinary is being woven. Return soon.
        </p>

        {/* Decorative gold dots */}
        <div className="flex items-center gap-3 mb-16">
          {[1, 2, 3].map((i) => (
            <span
              key={i}
              className="rounded-full"
              style={{
                width: i === 2 ? '8px' : '5px',
                height: i === 2 ? '8px' : '5px',
                background: i === 2 ? '#C9A84C' : 'rgba(201,168,76,0.4)',
              }}
            />
          ))}
        </div>

        {/* Scroll hint */}
        <div className="flex flex-col items-center gap-2 opacity-30">
          <span
            className="text-[10px] tracking-[0.3em] uppercase"
            style={{ fontFamily: "'Inter', sans-serif", color: '#F5F0E8' }}
          >
            Scroll
          </span>
          <i className="ri-arrow-down-line text-[#F5F0E8] animate-bounce" />
        </div>
      </div>
    </section>
  );
}
